import { Navigate } from "react-router-dom";
import { NotificationsCenter } from "../../../components/Notifications";
import { useInvestorSession } from "../../../hooks/useInvestorSession";

/**
 * Investor notification inbox — reuses NotificationsCenter.
 * Cooperative members keep the member notification centre.
 */
export default function InvestorNotificationsPage() {
  const { isMember } = useInvestorSession();
  if (isMember) {
    return <Navigate to="/member/notifications" replace />;
  }
  return <NotificationsCenter guard="investor" />;
}
